// all fields for new submission form
import loanUseValues from './loanUseValues';
import { APPLICATION_FIELDS } from './serverFieldMappings';

export default {
  section1: [
    {display: 'Financing Information', inputType: 'title', required: false, useMask: false, placeHolder: ''},
    {modelVal: APPLICATION_FIELDS.LOAN_USE, display:'Use and Impact of Funds', inputType: 'dropdown', options: loanUseValues, required: true, useMask: false, placeHolder: ''},
    {modelVal: APPLICATION_FIELDS.NOTES, display: 'Notes For Underwriter', inputType: 'textarea', required: false, useMask: false, placeHolder: 'Include any information here that would help the underwriter review the file and give the most competitive approval.'}
  ],
  section2: [
    {display: '', inputType: 'title', required: false},
    {modelVal: 'uploadDocuments', display: 'Upload Documents', inputType: 'file', required: true}
  ]
};
